module.exports = __webpack_public_path__ + "img/CS26Q-中_03.b3f16d9f.jpg";